var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.mode == "edit"
        ? _c(
            "el-select",
            {
              staticClass: "wp-10",
              attrs: {
                value: _vm.currentValue,
                filterable: "",
                multiple: _vm.multiple,
                placeholder: _vm.placeholder
              },
              on: { change: _vm.update }
            },
            [
              _vm._t(
                "option",
                _vm._l(_vm.options, function(item) {
                  return _c("el-option", {
                    key: item[_vm.idColumn],
                    attrs: {
                      label: item[_vm.labelColumn],
                      value: parseInt(item[_vm.idColumn])
                    }
                  })
                })
              )
            ],
            2
          )
        : _c(
            "p",
            [
              _c("person-list", {
                attrs: {
                  list: _vm.selectedItems,
                  size: "small",
                  relatedData: _vm.relatedData
                }
              })
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }